module.exports = __webpack_public_path__ + "static/media/11.148a1304.jpg";